import { useEffect, type ReactNode } from 'react';
import { usePopover } from './use-popover';

export const Dropdown = ({
  label,
  trigger,
  triggerClassName,
  panelClassName,
  haspopup,
  autoFocusItem = false,
  children,
}: {
  label: string;
  trigger: ReactNode;
  triggerClassName?: string;
  panelClassName?: string;
  haspopup?: 'menu';
  autoFocusItem?: boolean;
  children: (close: () => void) => ReactNode;
}) => {
  const { open, close, toggle, panelId, panelRef, triggerRef } = usePopover<HTMLUListElement>();

  useEffect(() => {
    if (!open || !autoFocusItem) return;
    panelRef.current?.querySelector<HTMLElement>('a, button')?.focus();
  }, [autoFocusItem, open, panelRef]);

  return (
    <div className="relative">
      <button
        ref={triggerRef}
        type="button"
        className={triggerClassName}
        aria-label={label}
        aria-expanded={open}
        aria-controls={panelId}
        aria-haspopup={haspopup}
        onClick={toggle}
      >
        {trigger}
      </button>
      <ul
        ref={panelRef}
        id={panelId}
        aria-label={label}
        hidden={!open}
        className={
          panelClassName ??
          'absolute right-0 z-10 mt-2.5 w-56 origin-top-right rounded-md bg-surface py-2 shadow-lg shadow-shadow/15 ring-1 ring-line focus:outline-hidden'
        }
      >
        {children(close)}
      </ul>
    </div>
  );
};
